/* Фрагменты словаря экранов студии на движке шаблона (план вехи 3, S7). Каждый экран пишет только свой файл i18n/screens/<экран>.json:
   {"en": {"Русский шаблон": "перевод", …}, "de": {…}, …} — все 9 языков с одинаковыми ключами и подстановками ({0}, {1}), строки
   движка экрана (ut, uf) и своего адаптера. Общие строки ядра (BotCore, BotPeople, BotRun, engine-kit) — в основных словарях locales/*.json.
   Список явный (import.meta.glob нет: vitest 5 кэширует списки модулей, mocks/studio-forms.ts:48): места для всех 13 движков вехи 3
   заведены сразу, поэтому экран правит только свой файл. photo — общий движок «Фото» и «Видео», who — «Говорящий кружок» (circle,
   lipsync), dance — «Повтори движения» и «Стать персонажем». i18n/index.ts сливает фрагменты с основными словарями;
   i18n/index.test.ts стережёт полноту языков и то, что фрагмент не переопределяет перевод основного словаря или другого фрагмента. */
import avatar from './avatar.json';
import collage from './collage.json';
import cover from './cover.json';
import dance from './dance.json';
import infog from './infog.json';
import mcard from './mcard.json';
import photo from './photo.json';
import post from './post.json';
import pshoot from './pshoot.json';
import reels from './reels.json';
import shoot from './shoot.json';
import text from './text.json';
import who from './who.json';

/** Языки профиля кроме русского (русский — сами ключи) */
export const LOCALES = ['en', 'hy', 'es', 'de', 'fr', 'pt', 'tr', 'kk', 'uk', 'zh'] as const;
export type Locale = (typeof LOCALES)[number];
/** Фрагмент экрана: перевод по языкам; пустой объект — экран ещё без своих строк */
export type ScreenFragment = Partial<Record<Locale, Record<string, string>>>;

/** Фрагменты по имени экрана (порядок слияния не важен: совпадающий ключ обязан иметь тот же перевод) */
export const SCREEN_FRAGMENTS: Readonly<Record<string, ScreenFragment>> = Object.freeze({
  who,
  photo,
  reels,
  cover,
  text,
  dance,
  avatar,
  shoot,
  pshoot,
  collage,
  infog,
  post,
  mcard,
});
